"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _withAuthentication = _interopRequireDefault(require("../../hocs/withAuthentication"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _PageFooterComponent = _interopRequireDefault(require("../PageFooter/PageFooterComponent"));
var _TotalTokensCount = require("./TotalTokensCount");
require("./DigitalAssetsPage.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var classes = (0, _cssClassesHelper.getBEMClasses)('digital-assets');
var DigitalAssetsPage = function DigitalAssetsPage(_ref) {
  var products = _ref.products,
    digitalAssets = _ref.digitalAssets,
    getProductAttributes = _ref.getProductAttributes;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    getProductAttributes(products);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('accent-bar')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container')
  }, !products.length ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null) : digitalAssets.length ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container-header')
  }, "Ongoing Offerings"), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('col', ['lg'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container-with-shadow')
  }, digitalAssets.map(function (card, index) {
    var total = digitalAssets.find(function (total) {
      return total.Product1 === card.ProductId || total.Product2 === card.ProductId;
    }) || {
      total: 0
    };
    return /*#__PURE__*/_react["default"].createElement(Card, {
      data: card,
      total: total,
      key: index
    });
  })))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container-notfound')
  }, t('No Digital Assets could be found'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('footer')
  }, /*#__PURE__*/_react["default"].createElement(_PageFooterComponent["default"], null)));
};
var Card = function Card(_ref2) {
  var data = _ref2.data;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('card')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('header-div'),
    style: {
      backgroundImage: "url(".concat(data.ProductImageURL, ")")
    }
  }, ' '), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('card-title')
  }, data.ProductFullName), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('card-description')
  }, data.ProductDescription), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('card-symbol')
  }, data.Product), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('details')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('left-detail')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('details-label')
  }, t('Amount of tokens offered:')), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('details-value')
  }, /*#__PURE__*/_react["default"].createElement(_TotalTokensCount.ConnectedTotalTokens, {
    ProductId: data.ProductId
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('card-actions')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('view-more')
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/token-offerings/".concat(data.ProductId)
  }, t('View More'), " \xA0\xA0", /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowNext"
  }))))));
};
Card.defaultProps = {
  ProductImageURL: "http://offering-profiles-samples.surge.sh/noimagefound.png"
};
var _default = exports["default"] = (0, _withAuthentication["default"])(DigitalAssetsPage);